import React from "react";

/**
 * The heading every usage card wears: what the card counts, one line on how it
 * counts it, and whatever the card puts on the right — a total, a search field.
 *
 * It stacks under `sm`, so a search field beside a heading drops below it on a
 * phone instead of squeezing the title to two characters.
 */
const UsageSectionHeader = ({ icon: Icon, title, subtitle, aside }) => (
  <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between sm:gap-4">
    <div className="min-w-0">
      <h2 className="flex items-center gap-2 text-base font-semibold text-text-primary">
        {Icon ? <Icon className="h-4 w-4 flex-shrink-0 text-text-secondary" /> : null}
        {title}
      </h2>
      {subtitle ? <p className="mt-1 text-[12px] leading-relaxed text-text-secondary">{subtitle}</p> : null}
    </div>
    {aside ? <div className="flex-shrink-0">{aside}</div> : null}
  </div>
);

export default UsageSectionHeader;
